// extracted by mini-css-extract-plugin
export default {"google":"ButonGoogle_google__LYXWZ","txtGoogle":"ButonGoogle_txtGoogle__IpRzB"};